export default {
	methods: 
    {		
		filterSelects(list)
		{
			return _.filter(this.lists[list],['id_list_estado',1])
		},
		nuevoModal()
		{
		  this.resetDataIndex()
		  this.updateGlobal({state: 'openModal/modal/value',    data: true });
		  this.updateGlobal({state: 'openModal/modal/title',    data: 'Registrar Egreso'});
		  this.updateGlobal({state: 'openModal/modal/modal',    data: 'Nuevo'});
		},
		async getFiltrar()
		{
			let dataRoute={}
			let others=[]
			let filterKeys= Object.keys(this.filter);
			for (let i = 0; i < filterKeys.length; i++) {
				if(filterKeys[i]==='inicial')
				{
					(this.filter.inicial==='') ? dataRoute.inicial= this.fecha().inicioLabores.servicios : dataRoute.inicial= this.filter.inicial;
					
				}		
				if(filterKeys[i]==='final')
				{
					(this.filter.final==='') ? dataRoute.final= this.fecha().inicioLabores.servicios : dataRoute.final= this.filter.final;
				}	
				if(filterKeys[i]!=='inicial' && filterKeys[i]!=='final' && this.filter[filterKeys[i]]!==''  && this.filter[filterKeys[i]]!==null)
				{
					others.push([filterKeys[i],this.filter[filterKeys[i]].id ])
				}	
			}
			dataRoute.others=others
			await this.getDataGet({ route: 'get_egresosinformes', data: dataRoute})
			//frontend await this.searchGetIdb({tabla:'afiliacion_registro', campo:'id_datos_asesor', value: this.filter.servicios.id})
		},	
		async getLimpiar()
		{
			this.filter = {
				inicial:this.fecha().fecha.minHoy,
				final: this.fecha().fecha.minHoy,
				id_datos_asesor: null,
				id_datos_razon: null
			}
			
			await this.getDataGet({route: 'get_egresosinformes', data: { inicial: this.fecha().fecha.minHoy, final: this.fecha().fecha.minHoy, others: []}})
			// frontend await this.searchGetIdb({tabla:'afiliacion_registro'})
		}
	},
}